import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  grey1,
  grey2,
  grey3,
  grey4,
  grey7,
  grey8,
  purple5,
} from 'approot/shared/styles/colours.style';
import {
  spacing4,
  spacing8,
  spacing16,
  spacing24,
} from 'approot/shared/styles/spacing.style';
import {
  font18,
  Heading16,
  SmallStyled,
} from 'approot/shared/styles/typography.style';
import {
  borderRadius8,
  standardFocusStateInset,
} from 'approot/shared/styles/borders.style';
import { BoxList } from 'approot/shared/design-system/box/box.style';
import { SettingsComponentMenuButton } from 'approot/activity-builder/settings/settings-component-menu.style';
import {
  ActivityBuilderDrawerContent,
  ActivityBuilderDrawerHeader,
  ActivityBuilderDrawerWrapper,
} from 'approot/activity-builder/activity-builder-drawer.style';
import {
  flexCentreAlignCss,
  flexColumnCss,
} from 'approot/shared/styles/flex.style';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';

export const ComponentAddMenuItemList = styled(BoxList)``;

export const ComponentAddMenuItem = styled.button`
  ${font18}
  background-color: ${grey1};
  border: none;
  color: ${grey7};
  display: flex;
  align-items: center;
  padding: ${rem(spacing8)} ${rem(spacing24)};
  width: 100%;
  text-decoration: none;

  ${standardFocusStateInset}

  &:focus {
    color: ${grey8};
  }
  &:focus:not(:focus-visible) {
    color: ${grey7};
  }
  &:focus-visible {
    color: ${grey8};
  }

  &:hover,
  &:hover:active {
    background-color: ${grey2};
    color: ${grey8};
    cursor: pointer;
  }
`;

export const ComponentAddMenuSubItem = styled(ComponentAddMenuItem)`
  background-color: transparent;
  border-bottom: 1px solid ${grey4};
  display: block;
  padding: ${rem(spacing24)} ${rem(spacing16)};
  text-align: left;

  &:hover {
    cursor: grab;
  }
`;

export const ComponentAddMenuImage = styled.div`
  background-color: ${grey1};
  border: 1px solid ${grey4};
  border-radius: ${rem(4)};
  overflow: hidden;
  position: relative;
  padding-top: 62%;

  picture {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  img {
    width: 100%;
  }
`;

export const ComponentAddMenuItemText = styled(Heading16).attrs({
  as: 'h2',
  marginBottom: spacing4,
  marginTop: spacing16,
})``;

export const ComponentAddMenuItemDescription = styled(SmallStyled).attrs({
  marginBottom: 0,
})``;

export const ComponentAddMenuButton = styled(SettingsComponentMenuButton)`
  svg {
    stroke: none;
  }
`;

export const ComponentAddMenuWrapper = styled(ActivityBuilderDrawerWrapper)`
  ${ActivityBuilderDrawerHeader} {
    background-color: ${grey3};
  }

  ${ActivityBuilderDrawerContent} {
    background-color: ${grey3};
  }
`;

export const ComponentAddMenuTarget = styled.div`
  @keyframes growAnimation {
    0% {
      width: 0;
    }
    100% {
      width: 100%;
    }
  }

  ${flexCentreAlignCss}
  height: ${rem(24)};
  width: 100%;

  &:before {
    content: '';
    display: block;
    border-radius: ${rem(borderRadius8)};
    height: ${rem(8)};
    background-color: ${purple5};
    animation: growAnimation 300ms cubic-bezier(0.65, 0.05, 0.36, 1) forwards;
    transform-origin: center;
    width: 0;
  }
`;

export const ComponentAddMenuSearch = styled.div`
  ${flexColumnCss}
  padding: ${rem(spacing16)};
  ${SecondaryButton} {
    display: flex;
    justify-content: center;
    width: 100%;
  }
`;
